import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";

let cancelToken;

const brandModURL = "api/v1/account-app/vouchertypes";

//obtaining the paginated data
export const getVoucherType = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${brandModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllVoucherType = () => axiosInstance.get(`${brandModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageVoucherType = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${brandModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createVoucherType = (body) => axiosInstance.post(`${brandModURL}/create`, body);
//updating function
export const updateVoucherType = (id, body) => axiosInstance.patch(`${brandModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${brandModURL}/list?offset=0&limit=${rowsPerPage} &ordering=${sortOrder} &search=${search}`);

// checking the redundant data
export const checkRedundantDataVoucherTypeName = (e, cancelToken) =>
  axiosInstance.get(`${brandModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
